// extracted by mini-css-extract-plugin
export default {"payment_button":"Razorpay_payment_button__J24ES","footer_payment_button":"Razorpay_footer_payment_button__oAmky","teacher_profile":"Razorpay_teacher_profile__-4LGK"};